// extracted by mini-css-extract-plugin
export var navLink = "skip-nav-module--navLink--QA913";